import { AppThunk, AppDispatch } from '@app/store/store'
import { cmsSdk } from '@app/api/endpoints'

import { actions } from './slice'

export const getLocations = (): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.requestFetchLocations())
  try {
    const response = await cmsSdk.GetLocations()
    dispatch(actions.successFetchLocations(response.states))
  } catch (error) {
    dispatch(actions.requestFetchLocationsError(error.errors?.[0]?.message))
  }
}

export const getState = (slug: string): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.requestFetchState())
  try {
    const response = await cmsSdk.GetState({ slug })
    dispatch(actions.successFetchState(response.state))
    return response
  } catch (error) {
    dispatch(actions.requestFetchStateError(error.errors?.[0]?.message))
    return null
  }
}

export const getCity = (slug: string): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.requestFetchCity())
  try {
    const response = await cmsSdk.GetCity({ slug })
    dispatch(actions.successFetchCity(response.city))
    return response
  } catch (error) {
    dispatch(actions.requestFetchCityError(error.errors?.[0]?.message))
    return null
  }
}

export const resetLocationsStatus = (): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.resetFetchStatus())
}
